import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Details from '../views/Details.vue'
import Schedules from '../views/schedules.vue'
import Profile from '../views/Profile.vue'
import Team from '../views/Team.vue'
import Platforms from '../views/Platforms.vue'
import Plans from '../views/Plans.vue'
import Register from '../views/Register.vue'
import Login from '../views/Login.vue'
import MeetingDate from '../views/meeting/Date.vue'
import MeetingsIndex from '../views/meeting/Index.vue'
import TimePicker from '../views/meeting/TimePicker.vue'
import MeetingEdit from '../views/meeting/Edit.vue'
import SuccessPage from '../views/meeting/Success.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/details',
    name: 'Details',
    component: Details
  },
  {
    path: '/schedules',
    name: 'Schedules',
    component: Schedules
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile
  },
  {
    path: '/team',
    name: 'Team',
    component: Team
  },
  {
    path: '/platforms',
    name: 'Platforms',
    component: Platforms
  },
  {
    path: '/plans',
    name: 'Plans',
    component: Plans
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/meeting/date',
    name: 'MeetingDate',
    component: MeetingDate
  },
  {
    path: '/meeting/time',
    name: 'TimePicker',
    component: TimePicker
  },
  {
    path: '/meeting',
    name: 'MeetingsIndex',
    component: MeetingsIndex
  },
  {
    path: '/meeting/edit',
    name: 'MeetingEdit',
    component: MeetingEdit
  },
  {
    path: '/meeting/success',
    name: 'SuccessPage',
    component: SuccessPage
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
